import { WrapSmMarginBottom } from "App/global-style";
import { useTexts } from "Components/TextContext";
import { Button, Ingress } from "Components/TextContext/commonComponentEnums";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import React from "react";
import { useBankIdLoginHandler } from "../bankIdLoginHooks";
import { StyledIngress } from "../styled";
import {
  BANK_ID_LOGIN_BUTTON_TRACK_ID,
  SWITCH_TO_NO_BANK_ID_LOGIN_BUTTON_TRACK_ID,
} from "./alternativeProductLoginConstants";

interface Props {
  setBankIdMode: (status: boolean) => void;
}

export const AlternativeBankIdLogin = ({
  setBankIdMode,
}: Props): React.ReactElement => {
  const handleBankIdLogin = useBankIdLoginHandler();
  const { getText } = useTexts();
  return (
    <>
      <StyledIngress>{getText(Ingress.LOGIN_BANKID)}</StyledIngress>

      <WrapSmMarginBottom>
        <ThemedButton
          onClick={() => handleBankIdLogin()}
          trackId={BANK_ID_LOGIN_BUTTON_TRACK_ID}
        >
          {getText(Button.IDENTIFY_WITH_BANK_ID)}
        </ThemedButton>
      </WrapSmMarginBottom>

      <ThemedButton
        trackId={SWITCH_TO_NO_BANK_ID_LOGIN_BUTTON_TRACK_ID}
        onClick={() => setBankIdMode(false)}
        variant="outlined"
      >
        {getText(Button.IDENTIFY_WITHOUT_BANK_ID)}
      </ThemedButton>
    </>
  );
};
